export const DOOH_REPORT_SUMMARY_LOADED = "DOOH_REPORT_SUMMARY_LOADED";


export const END_URL = {
    DETAIL_REPORT: '/dooh-report/summary_report/detail-report',
}

export const TOAST_LABEL = {
    SELECT_ADVERTISER:"Please select advertiser",
    SWITCH_TABLE_TYPE:"Please switch the table type"
};
export const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
}